import { Component, input, inject } from "@angular/core";
import { NavigationBarItem } from "./model/navigation-bar-item";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";

@Component({
  selector: "portal-navigation-bar",
  templateUrl: "./navigation-bar.component.html",
  styleUrls: ["./navigation-bar.component.scss"],
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
})
export class NavigationBarComponent {
  readonly items = input<NavigationBarItem[]>([]);
  readonly #router = inject(Router);

  navigateToRoute(item: NavigationBarItem): void {
    this.#router.navigate([item.routerLinkUrl], { queryParamsHandling: "merge" });
  }
}
